import React, { Component } from 'react';

import { Markdown, Button } from "grommet";
import { Helmet } from "react-helmet";
import { navigate } from "gatsby"

// import { SecretClient } from "@azure/keyvault-secrets";


export default class LoginComponent extends Component {

  constructor() {
    super();
    this.state = {
      loggedin: false
    };
    this.setLogin = this.setLogin.bind(this);
    this.appdetails = {
      clientId: "720f8c6b-406e-473c-8f48-103c54ccbbc1",
      authorityHost: "https://login.microsoftonline.com",
      tenantId: "c5f9cef3-6300-4cc2-90f6-be1b3f6e31d8"
    };
    this.sc = { scopes: ["api://720f8c6b-406e-473c-8f48-103c54ccbbc1/Channel.Read", "api://720f8c6b-406e-473c-8f48-103c54ccbbc1/Channel.Write"] };

  }

  async componentDidMount() {
    const { InteractiveBrowserCredential } = await import(/* webpackChunkName: "@azure/identity" */ '@azure/identity');

    const defaultAzureCredential = new InteractiveBrowserCredential(this.appdetails);
    this.defaultAzureCredential = defaultAzureCredential;
    const account = defaultAzureCredential.msalObject.getAccount();

    if(account) { // get token, if already logged in
      await this.setLogin(false);
    }
    this.setState({
      loggedin: !!account,
    });
  }

  async setLogin(shouldNavigate) {
    const path = window.location.pathname;
    if(shouldNavigate !== false) {
      navigate(
          "/",
          { replace: true },
        );
    }
    const tkl = await this.defaultAzureCredential.getToken(this.sc.scopes);
    if(shouldNavigate !== false) {
      navigate(
          path,
          { replace: true },
        );
    }

    this.setState({
      loggedin: !!this.defaultAzureCredential.msalObject.getAccount(),
      token: tkl.token,
      defaultAzureCredential: this.defaultAzureCredential,
    });
  }

  render() {
    if(this.props.overWrite) {
      return <div>{this.props.children(this.state)}</div>;
    }
    return !this.state.loggedin ? (<div>
      <p>You need to log in to see this report {`${this.state.loggedin}`}</p>
      <Button onClick={this.setLogin} label="Log in" primary />
    </div>) : (<div>{this.props.children(this.state)}</div>);
  }
}
